import {useCallback} from 'react';
import {useNavigate, useSearchParams} from 'react-router-dom';

export default function () {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();

  /**
   * Override setSearchParams to avoid having encoded URLs
   */
  const setSearchParams = useCallback(
    params => {
      navigate(`?${decodeURIComponent(params.toString())}`);
    },
    [navigate]
  );

  return {searchParams, setSearchParams};
}
